import { render } from "./RankingPreviewTeam.vue?vue&type=template&id=22a39132&scoped=true"
import script from "./RankingPreviewTeam.vue?vue&type=script&lang=js"
export * from "./RankingPreviewTeam.vue?vue&type=script&lang=js"

import "./RankingPreviewTeam.vue?vue&type=style&index=0&id=22a39132&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a39132"]])

export default __exports__